module.exports = __webpack_public_path__ + "img/pr.16828b38.svg";